export default interface TAB_MENU
{
	MODULE_NAME                   : string;
	DISPLAY_NAME                  : string;
	RELATIVE_PATH                 : string;
	EDIT_ACLACCESS                : number;
	EDIT_LABEL                    : string;
}

